(function () {
  const root = document.querySelector('[data-uk-saved-boards]');
  if (!root || root.dataset.initialized === 'true') return;
  const stickyContainer = document.querySelector('[data-uk-saved-panels]') || root;
  const avatars = root.querySelector('[data-uk-saved-boards-avatars]');
  const count = root.querySelector('[data-uk-saved-boards-count]');
  const openButton = root.querySelector('[data-uk-saved-boards-open]');
  const dialog = root.querySelector('[data-uk-saved-boards-dialog]');
  const closeButton = root.querySelector('[data-uk-saved-boards-close]');
  const grid = root.querySelector('[data-uk-saved-boards-grid]');
  const empty = root.querySelector('[data-uk-saved-boards-empty]');
  const productId = String(root.dataset.productId || '');
  let productUrl;
  try {
    productUrl = new URL(root.dataset.productUrl, window.location.origin);
    if (productUrl.origin !== window.location.origin || productUrl.username || productUrl.password || !/\/products\/[^/]+\/?$/.test(productUrl.pathname)) return;
    productUrl.search = '';
    productUrl.hash = '';
  } catch { return; }
  if (!avatars || !count || !openButton || !dialog || !closeButton || !grid || !empty || !/^\d+$/.test(productId)) return;
  root.dataset.initialized = 'true';

  const storageKey = 'bellissima.savedChoppingBoards.v1';
  const maxEntries = 5;
  let memoryEntries = [];
  let memoryOnly = false;
  const imageUrl = value => {
    if (typeof value !== 'string' || !/^https:\/\//i.test(value.trim())) return '';
    try {
      const url = new URL(value.trim());
      return url.protocol === 'https:' && !url.username && !url.password ? url.toString() : '';
    } catch { return ''; }
  };
  const sanitize = entry => {
    if (!entry || typeof entry !== 'object' || Array.isArray(entry) || String(entry.productId || '') !== productId) return null;
    const id = typeof entry.id === 'string' ? entry.id.trim() : '';
    const dogName = typeof entry.dogName === 'string' ? entry.dogName.trim() : '';
    const stage1Url = imageUrl(entry.stage1Url);
    const finalUrl = imageUrl(entry.finalUrl);
    const createdAt = typeof entry.createdAt === 'string' ? Date.parse(entry.createdAt) : NaN;
    if (!/^[a-z0-9_-]{1,128}$/i.test(id) || !dogName || dogName.length > 60 || !stage1Url || !finalUrl || !Number.isFinite(createdAt)) return null;
    return { id, productId, dogName, stage1Url, finalUrl, createdAt: new Date(createdAt).toISOString() };
  };
  const normalize = entries => {
    if (!Array.isArray(entries)) return [];
    const sorted = entries.map(sanitize).filter(Boolean).sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));
    const seenUrls = new Set();
    const seenIds = new Set();
    return sorted.filter(entry => {
      if (seenUrls.has(entry.finalUrl) || seenIds.has(entry.id)) return false;
      seenUrls.add(entry.finalUrl);
      seenIds.add(entry.id);
      return true;
    }).slice(0, maxEntries);
  };
  const readEntries = () => {
    if (memoryOnly) return memoryEntries;
    let raw;
    try { raw = window.localStorage.getItem(storageKey); }
    catch { memoryOnly = true; return memoryEntries; }
    try { memoryEntries = normalize(JSON.parse(raw || '[]')); }
    catch { memoryEntries = []; }
    return memoryEntries;
  };
  const boardLink = entry => {
    const url = new URL(productUrl);
    url.searchParams.set('dpc_saved', entry.id);
    const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewTheme && /^\d+$/.test(previewTheme)) url.searchParams.set('preview_theme_id', previewTheme);
    return url.toString();
  };
  const syncVisibility = () => {
    root.hidden = !readEntries().length;
    if (root.hidden && dialog.open) dialog.close();
    stickyContainer.hidden = window.__DPC_READY === true || Boolean(document.querySelector(
      'main [data-uk-portrait][data-view="ready"], main .gemini-transformer--hidden'
    ));
    if (stickyContainer.hidden) {
      stickyContainer.querySelectorAll('dialog[open]').forEach(openDialog => openDialog.close());
    }
  };
  const makeImage = entry => {
    const image = new Image();
    image.src = entry.finalUrl;
    image.alt = '';
    image.referrerPolicy = 'no-referrer';
    image.decoding = 'async';
    return image;
  };
  const render = () => {
    if (!root.isConnected) return;
    const entries = readEntries();
    count.textContent = entries.length
      ? `${entries.length} ${entries.length === 1 ? 'design' : 'designs'} ready to finish`
      : 'No saved chopping boards yet';
    avatars.replaceChildren(...entries.slice(0, 3).map(makeImage));
    avatars.hidden = !entries.length;
    grid.replaceChildren(...entries.map(entry => {
      const card = document.createElement('a');
      card.className = 'pop-saved-portraits__card';
      card.href = boardLink(entry);
      const image = makeImage(entry);
      image.loading = 'lazy';
      const label = document.createElement('span');
      label.className = 'pop-saved-portraits__card-label';
      label.textContent = entry.dogName;
      card.setAttribute('aria-label', `Continue chopping board for ${entry.dogName}`);
      card.append(image, label);
      return card;
    }));
    grid.hidden = !entries.length;
    empty.hidden = Boolean(entries.length);
    syncVisibility();
  };

  const save = entry => {
    if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return null;
    const current = readEntries();
    const existing = current.find(candidate => candidate.finalUrl === imageUrl(entry.finalUrl));
    const id = entry.id || existing?.id || `board-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    const saved = sanitize({ ...entry, id, createdAt: entry.createdAt || existing?.createdAt || new Date().toISOString() });
    if (!saved) return null;
    memoryEntries = normalize([saved, ...current.filter(candidate => candidate.id !== saved.id && candidate.finalUrl !== saved.finalUrl)]);
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(memoryEntries));
      memoryOnly = false;
    } catch { memoryOnly = true; }
    render();
    return { ...saved };
  };
  const find = id => {
    if (typeof id !== 'string') return null;
    const entry = readEntries().find(candidate => candidate.id === id);
    return entry ? { ...entry } : null;
  };

  openButton.addEventListener('click', () => {
    render();
    if (root.hidden) return;
    const entries = readEntries();
    if (entries.length === 1) {
      window.location.assign(boardLink(entries[0]));
      return;
    }
    dialog.showModal();
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('pop-saved-portraits-open');
  });
  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('pop-saved-portraits-open');
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  document.addEventListener('dpc:readiness-change', syncVisibility);
  window.addEventListener('storage', event => { if (event.key === null || event.key === storageKey) render(); });
  window.addEventListener('pageshow', render);

  const main = document.querySelector('main');
  if (main) new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || record.target.matches?.('[data-uk-portrait], .gemini-transformer'))) syncVisibility();
  }).observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-view'] });

  // Keep the strip immediately below the visible header as it scrolls.
  const header = document.querySelector('.site-header') || document.querySelector('.header-section');
  let positionFrame = 0;
  let previousTop = -1;
  const position = () => {
    positionFrame = 0;
    const top = header && getComputedStyle(header).opacity !== '0' ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    if (top !== previousTop) {
      stickyContainer.style.setProperty('--pop-saved-portraits-top', `${top}px`);
      previousTop = top;
    }
  };
  const schedulePosition = () => { if (!positionFrame) positionFrame = requestAnimationFrame(position); };
  window.addEventListener('scroll', schedulePosition, { passive: true });
  window.addEventListener('resize', schedulePosition);
  if (header && typeof ResizeObserver !== 'undefined') new ResizeObserver(schedulePosition).observe(header);
  window.UKSavedChoppingBoards = { save, find };
  position();
  render();
  document.dispatchEvent(new CustomEvent('uk:saved-chopping-boards-ready'));
})();
